
import $ from 'jquery';


let promise = null;
export const getLibPhoneNumber = () => {

	if ( window.libphonenumber ) {
		return window.libphonenumber;
	}

	return promise ??= new Promise( ( resolve, reject ) =>  {

		// This prevents the script being loaded multiple times, if the validation is called for multiple fields simultaneously.
		const scriptEl = document.createElement( 'script' );
		scriptEl.type = 'text/javascript';
		scriptEl.async = true;
		scriptEl.src = '/out/kastnergigasport/src/js/libs/libphonenumber-js.min.js';

		scriptEl.onload = () => setTimeout( () => resolve( window.libphonenumber ) );
		scriptEl.onerror = () => reject();

		document.head.append( scriptEl );
	} );
};

const getCountryCode = ( countryId ) => {

	const url = new URL( '/index.php?cl=user&fnc=getISO2ByCountryCode', document.baseURI );
	url.searchParams.append( 'countryId', countryId );
	return fetch( url ).then( res => res.text() );
};

export function parsePhoneNumber( inputValue, countryId ) {

	// Get libphonenumber library.
	const promises = [ () => getLibPhoneNumber() ];

	// Trim phonenumber
	const phone = inputValue.trim();

	if ( typeof countryId === 'undefined' || phone.startsWith( '+' ) || ! phone ) {
		// Do nothing.
	} else {
		// Fetch countryCode for second parameter if needed.
		promises.push( () => getCountryCode( countryId ) );
	}

	// Wait for our promises of libphonenumber and countrycode.
	return Promise.all( promises.map( promise => promise() ) )
		.then( ( [ libphonenumber, countryCode ] ) => {

			// Then initialise libphonenumber.
			const lib = new libphonenumber.AsYouType( countryCode );
			lib.input( phone );

			return lib;
		}
		);
}
